import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 目的港派车List
export function getDischargingTruckingList(params) {
  return request({
    url: URL.seaExport.getDischargingTruckingList,
    method: 'get',
    params
  })
}

// 根据目的港派车uuid获取装箱明细
export function getDischargingTruckingContainerUsages(params) {
  return request({
    url: URL.seaExport.getDischargingTruckingContainerUsages,
    method: 'get',
    params
  })
}

// 根据job查询目的港派车可用的装箱明细
export function queryAvailableDischargingContainerUsageByJob(params) {
  return request({
    url: URL.seaExport.queryAvailableDischargingContainerUsageByJob,
    method: 'get',
    params
  })
}

// 根据job查询目的港派车装箱明细关联信息
export function queryDischargingTruckingContainerUsageByJob(params) {
  return request({
    url: URL.seaExport.queryDischargingTruckingContainerUsageByJob,
    method: 'get',
    params
  })
}

// 目的港派车批量添加装箱明细关联
export function batchAddDischargingTruckingContainerUsages(data, params) {
  return request({
    url: URL.seaExport.batchAddDischargingTruckingContainerUsages,
    method: 'post',
    data,
    params
  })
}

// 目的港派车批量删除装箱明细关联
export function batchDeleteDischargingTruckingContainerUsages(data, params) {
  return request({
    url: URL.seaExport.batchDeleteDischargingTruckingContainerUsages,
    method: 'post',
    data,
    params
  })
}

// 目的港派车出口同步进口
export function dischargingTruckingExportSyncImport(params) {
  return request({
    url: URL.seaExport.dischargingTruckingExportSyncImport,
    method: 'post',
    params
  })
}
